module.exports = __webpack_public_path__ + "static/media/ppp_img.994991ae.png";